<app-table
  [cols]="cols"
  [lazy]="false"
  [expansionLazy]="false"
  [elements]="recurrences"
  modelName="recorrências"
  tableTitle=" "
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
  [actionButtons]="buttons"
  sortField="atualizacao.0.data"
  [sortOrder]="1"
  [defaultFilterValues]="defaultFilters"
  *ngIf="recurrences"
  (changedFilter)="
    $event.field === 'atualizacao.0.data' && findRecurrences($event.value)
  "
/>
<p-toast />
<p-confirmPopup />
